import ReactOnRails from 'react-on-rails';

import ReferralSubscription from '@components/pages/Referral/Subscription/index';

ReactOnRails.register({
  ReferralSubscription,
});
